import React, { FC } from 'react'
import { SubText, TitleH2 } from 'components/Common/Typography'
import { Col, Container, Row } from 'react-bootstrap'

const EighthSec: FC<{ data }> = ({ data }) => {
  return (
    <section className="hiring_process_verticle bg-black pt-120px pb-120px">
      <Container>
        <Row>
          <Col lg={8}>
            <TitleH2 className="mb-4" text={data?.title} />
            <SubText className="mb-4 text-light" text={data?.SubText} />
          </Col>
        </Row>
      </Container>
      <Container>
        <div className="content_wrapper d-flex mt-5">
          <Row className="align-items-stretch w-100">
            <Col
              lg={4}
              className="position-relative d-flex flex-column col_f_ordr"
            >
              <div
                className="content_block block_2 ps-4 ps-xl-5 text-end"
                data-aos="fade-up"
                data-aos-delay="2000"
                data-aos-once="true"
                data-aos-duration="400"
              >
                <span className="num">{data?.boxNumber4}</span>
                <h3 className="title_xs mb-2">{data?.boxTitle4}</h3>
                <p className="text_para text-light">{data?.boxDec4}</p>
              </div>
              <div
                className="content_block block_3 mt-auto text-end"
                data-aos="fade-up"
                data-aos-delay="1600"
                data-aos-once="true"
                data-aos-duration="400"
              >
                <span className="num">{data?.boxNumber3}</span>
                <h3 className="title_xs mb-2">{data?.boxTitle3}</h3>
                <p className="text_para text-light">{data?.boxDec3}</p>
              </div>
            </Col>
            <Col lg={4} className="col_s_ordr">
              <div className="svg_block">
                <div
                  className="svg_text text-center"
                  data-aos="fade-zoom-in"
                  data-aos-delay="2600"
                  data-aos-once="true"
                  data-aos-duration="2000"
                >
                  <h3 className="title_xs mb-2">{data?.boxTitle5}</h3>
                  <p className="text_para text-light mb-0">{data?.boxDec5}</p>
                </div>
                <svg
                  width="308"
                  height="308"
                  viewBox="0 0 308 308"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M154 307C238.5 307 307 238.5 307 154C307 69.5004 238.5 1 154 1C69.5004 1 1 69.5004 1 154C1 199.313 20.6988 240.026 52 268.041"
                    stroke="#fff"
                    className="circlepath"
                    data-aos="svg_line"
                    data-aos-offset="300"
                    data-aos-delay="1400"
                    data-aos-once="true"
                    data-aos-duration="2000"
                  />
                  <path
                    d="M48.5 268.5H52.5V264.5"
                    stroke="#fff"
                    strokeLinecap="round"
                    className="circlearrow"
                    data-aos="svg_arrow"
                    data-aos-offset="300"
                    data-aos-delay="2900"
                    data-aos-once="true"
                    data-aos-duration="400"
                  />
                </svg>
              </div>
            </Col>
            <Col
              lg={4}
              className="position-relative d-flex flex-column col_t_ordr"
            >
              <div
                className="verticleLine"
                // className="botmLine"
                data-aos="vert_line"
                data-aos-delay="350"
                data-aos-once="true"
                data-aos-duration="2000"
              >
                {' '}
              </div>
              <div
                className="content_block block_1"
                data-aos="fade-up"
                // data-aos-delay="800"
                data-aos-once="true"
                data-aos-duration="400"
              >
                <span className="num">{data?.boxNumber1}</span>
                <h3 className="title_xs mb-2">{data?.boxTitle1}</h3>
                <p className="text_para text-light">{data?.boxDec1}</p>
              </div>

              <div
                className="content_block block_4 mt-auto"
                data-aos="fade-up"
                data-aos-delay="1000"
                data-aos-once="true"
                data-aos-duration="400"
              >
                <span className="num">{data?.boxNumber2}</span>
                <h3 className="title_xs mb-2">{data?.boxTitle2}</h3>
                <p className="text_para text-light">{data?.boxDec2}</p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  )
}

export default EighthSec
